export default {
    auth: {
        baseUrl: window.REACT_APP_AUTH_URL ? window.REACT_APP_AUTH_URL:'https://dc-identityservice-test.k8n.synevo.intranet',
        client_id: window.REACT_APP_AUTH_CLIENT_ID ? window.REACT_APP_AUTH_CLIENT_ID:'DoctorCabinet',
        client_secret: window.REACT_APP_AUTH_CLIENT_SECRET ? window.REACT_APP_AUTH_CLIENT_SECRET:"secret",
    },
    api: {
        baseUrl: window.REACT_APP_API_URL ? window.REACT_APP_API_URL:'https://dc-dcgateway-api-test.k8n.synevo.intranet/api/v1',
    }
}